var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "overflow-auto body mobile:p-4 tablet:p-6",
      style: _vm.heightByIndex(0, _vm.prerender.length - 1),
      attrs: { "data-test": "tab-transcripts--results" },
      on: {
        scroll: function($event) {
          return _vm.renderWindow()
        },
        mousewheel: function($event) {
          return _vm.disableFollow()
        },
        DOMMouseScroll: function($event) {
          return _vm.disableFollow()
        }
      }
    },
    [
      _c("div", { style: { height: _vm.heightByIndex(0, _vm.start) + "px" } }),
      _c(
        "div",
        { style: { height: _vm.heightByIndex(_vm.start, _vm.end) + "px" } },
        _vm._l(_vm.slice(_vm.start, _vm.end), function(entry, index) {
          return _c("transcript-entry", {
            key: index,
            attrs: {
              entry: entry,
              playtime: _vm.playtime,
              "search-query": _vm.query,
              "ghost-active": _vm.ghostActive,
              "ghost-time": _vm.ghostTime,
              "search-results": _vm.searchResults,
              "chapter-style": _vm.chapterStyle,
              "speaker-style": _vm.speakerStyle,
              "highlight-style": _vm.highlightStyle,
              "active-style": _vm.activeStyle,
              "data-test": "tab-transcripts--entry"
            },
            on: {
              onClick: _vm.onClick,
              onMouseOver: _vm.onMouseOver,
              onMouseLeave: _vm.onMouseLeave
            }
          })
        }),
        1
      ),
      _c("div", {
        style: {
          height: _vm.heightByIndex(_vm.end, _vm.prerender.length - 1) + "px"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }